import React from "react";

const CLOSE_ANIM_MS = 260;

function NavbarCloseButton({ onClick, ariaLabel = "close menu" }) {
  const [closing, setClosing] = React.useState(false);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleClick = (event) => {
    if (closing) return;

    const reducedMotion =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reducedMotion) {
      onClick(event);
      return;
    }

    setClosing(true);
    timerRef.current = window.setTimeout(() => {
      onClick(event);
      setClosing(false);
      timerRef.current = null;
    }, CLOSE_ANIM_MS);
  };

  return (
    <button
      type="button"
      className={
        "navbar-menu-btn navbar-close-btn" +
        (closing ? " navbar-close-btn--closing" : "")
      }
      aria-label={ariaLabel}
      onClick={handleClick}
      disabled={closing}
    >
      <span className="navbar-close" aria-hidden="true">
        <span className="navbar-close-bar navbar-close-bar--a" />
        <span className="navbar-close-bar navbar-close-bar--b" />
      </span>
    </button>
  );
}

export default NavbarCloseButton;
